import React from 'react';
import { branch, renderComponent } from 'recompose';

import Money from '../../../../../common/money';

const ValueLoyalty = ({ survivingCustomer, duplicates, duplicateCellClass }) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/12">
      <div>Loyalty Money Amount</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">
        <Money>{survivingCustomer.loyaltyRewardCounter}</Money>
      </div>
    </div>
    {
      duplicates.map((d, idx) => (
        <div key={idx} className={duplicateCellClass}>
          <div className="u-type--semibold">
            <Money>{d.loyaltyRewardCounter}</Money>
          </div>
        </div>
      ))
    }
  </div>
);

const TransactionLoyalty = ({ survivingCustomer, duplicates, duplicateCellClass }) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/12">
      <div>Loyalty Counter</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">
        {survivingCustomer.loyaltyRewardCounter} appointments
      </div>
      <div className="u-type--semibold" display-if={survivingCustomer.loyaltyReward}>
        *A <Money>{survivingCustomer.loyaltyReward}</Money> reward to be issued after merge.
      </div>
    </div>
    {
      duplicates.map((d, idx) => (
        <div key={idx} className={duplicateCellClass}>
          <div className="u-type--semibold">
            {d.loyaltyRewardCounter} appointments
          </div>
        </div>
      ))
    }
  </div>
);

export default branch(
  props => props.survivingCustomer.loyaltyRewardType === 'transaction',
  renderComponent(TransactionLoyalty),
)(ValueLoyalty);
